import { PropsWithChildren } from 'react';

export const CrmLayoutRoot = ({ children }: PropsWithChildren) => {
  return <div className="grid grid-cols-1 gap-4 lg:grid-cols-6 2xl:grid-cols-11">{children}</div>;
};
